import { Box } from "@mui/material";
import React from "react";
import * as XLSX from "xlsx";
import { Dialog } from "../Dialogs/Dialog";
import { IFileExtension, convertBase64ToBlob } from "./helpers";
import "./RenderHtmlFromBase64.css";
// import { useFileDownloader } from "../../hooks/useFileDownloader";
import { PreviewCSVFile } from "../Preview/PreviewCSVFile";

export interface IViewImageDialog {
  open: boolean;
  file: string;
  fileType: IFileExtension;
  onClose: () => void;
  orgImageUrl?: string;
}
export const ViewImageDialog: React.FC<IViewImageDialog> = (props) => {
  const { open, file, fileType, onClose, orgImageUrl } = props;

  // const { downloadFile } = useFileDownloader();

  const handleNewTabClick = () => {
    // const url = `${process.env["REACT_APP_EXCEL_VIEW_URL_PREFIX"]}/${process.env["REACT_APP_SERVER_URL"]}/general/get-signed-url?key=${file}`;
    const url = `${process.env["REACT_APP_EXCEL_VIEW_URL_PREFIX"]}${process.env["REACT_APP_IMAGE_BASE_URL"]}/${file}`;
    window.open(url, "_blank");
  };

  return (
    <Dialog
      size={"xl"}
      open={open}
      title={""}
      // rightHeading={
      //   <Box>
      //     {fileType === "EXCEL" && (
      //       <Button
      //         variant="outlined"
      //         size="small"
      //         sx={{ color: "#fff", borderColor: "#fff" }}
      //         onClick={handleNewTabClick}
      //       >
      //         Open in New Tab
      //       </Button>
      //     )}

      //     <Button
      //       variant="outlined"
      //       size="small"
      //       sx={{ color: "#fff" }}
      //       onClick={() => downloadFile(orgImageUrl)}
      //     >
      //       <Download fontSize="small" />
      //     </Button>
      //   </Box>
      // }
      onClose={onClose}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
        // width="100%"
      >
        {fileType === "IMAGE" ? (
          <img alt="preview" src={file} style={{ maxHeight: "80vh" }} />
        ) : fileType === "PDF" ? (
          <iframe src={file} />
        ) : fileType === "EXCEL" ? (
          <iframe
            title="excel-file-view"
            src={`${process.env["REACT_APP_EXCEL_VIEW_URL_PREFIX"]}${process.env["REACT_APP_IMAGE_BASE_URL"]}/${file}`}
            style={{ width: "100%", height: "auto", minHeight: "90vh" }}
          />
        ) : fileType === "CSV" ? (
          <PreviewCSVFile filePath={file} />
        ) : (
          // <iframe
          //   src={`${process.env["REACT_APP_EXCEL_VIEW_URL_PREFIX"]}${process.env["REACT_APP_SERVER_URL"]}/general/get-signed-url?key=${file}`}
          // />
          <></>
        )}
      </Box>
    </Dialog>
  );
};

export const RenderHtmlFromBase64: React.FC<{ base64File: string }> = ({
  base64File,
}) => {
  const [__html, setHTML] = React.useState("");
  React.useEffect(() => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      // evt = on_file_select event
      const bstr = evt?.target?.result as ArrayBuffer;
      const workbook = XLSX.read(bstr, { type: "binary" });
      const worksheet_name = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheet_name];
      const data = XLSX.utils.sheet_to_html(worksheet);
      setHTML(data);
    };
    reader.readAsArrayBuffer(convertBase64ToBlob(base64File));
  }, []);
  return <div id="table_sheet" dangerouslySetInnerHTML={{ __html }} />;
};

export const RenderExcelFile: React.FC<{ fileUrl: string }> = ({ fileUrl }) => {
  return (
    <iframe
      src={fileUrl}
      style={{ width: "100%", height: "auto", minHeight: "90vh" }}
    />
  );
};
